import React, { useState, useRef, useEffect } from "react";
import logo from "../assets/images/Logo/web_logo.png";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { Link, useNavigate } from "react-router-dom";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { verifyOtp, resendOtp } from "../redux/thunks/registerThunks";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";

const OtpPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [seconds, setSeconds] = useState(120);
  const inputsRef = useRef([]);
  const { forgotUserId, forgototptype, forgotEmail, isLoading } = useSelector(
    (state) => state.login
  );

  useEffect(() => {
    if (!forgotUserId || !forgototptype) {
      toast.error("Please request OTP first");
      navigate("/forgot-password"); // redirect if state null
    }
  }, [forgotUserId, forgototptype]);
  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setError("");

    // Move focus to next input
    if (value && index < 3) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  useEffect(() => {
    if (seconds <= 0) return; // stop at 0

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval); // cleanup
  }, [seconds]);

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  // Resend OTP handler
  const handleresendOtp = async () => {
    if (seconds > 0) return; // button disabled check

    const payload = {
      user_id: forgotUserId,
      otp_type: forgototptype,
    };

    try {
      const res = await dispatch(resendOtp(payload)).unwrap(); // 🔹 unwrap ka magic
      // ab res me direct API response hai
      const message = res?.message || "OTP resent successfully";
      toast.success(
        typeof message === "string" ? message : JSON.stringify(message)
      );
      setSeconds(120); // 🔄 reset timer
    } catch (err) {
      const errMsg = err?.message || err || "Something went wrong";
      toast.error(typeof errMsg === "string" ? errMsg : JSON.stringify(errMsg));
    }
  };

  const handleVerify = async () => {
    const isOtpComplete = otp.every((digit) => digit !== "");
    if (!isOtpComplete) {
      setError("Please enter all 4 digits of OTP");
      return;
    }
    const payload = {
      user_id: forgotUserId,
      otp_type: forgototptype,
      otp: otp.join(""),
    };
    // console.log("The payload is : ", payload);
    try {
      const res = await dispatch(verifyOtp(payload)).unwrap();
      if (res.success) {
        toast.success(res.message || "OTP verified");
        navigate("/reset-password");
      } else {
        toast.error(res.message || "verify OTP fail");
      }
    } catch (err) {
      toast.error(err || "Something went wrong");
    }
  };

  return (
    <section className="flex   flex-col items-center justify-center min-h-screen w-full px-4 sm:px-6 md:px-10 bg-gray-50 lg:bg-gradient-to-br lg:from-orange-50 lg:to-orange-100">
      <DecorativeSquares />
      <div className="w-full space-y-4 sm:w-11/12 md:w-3/4 lg:w-[450px] xl:w-[400px] bg-white flex flex-col items-center text-center py-8 px-4 rounded-2xl shadow-none md:shadow-lg">
        {/* Logo & Tagline */}
        <div className="flex flex-col items-center gap-2 space-y-4">
          <img src={logo} alt="web_logo" className="w-20 h-20 object-contain" />
          <p className="text-gray-400 text-sm text-center">
            You Cook, We Manage the Rest
          </p>
          <p className="text-black text-lg text-center">Email Verification</p>
          <p className="text-gray-400 text-sm text-center">
            Enter your email to reset your password using OTP.
          </p>
        </div>

        {/* OTP Form */}
        <div className="w-full flex flex-col gap-5 text-start mt-8">
          <div className="flex flex-col gap-2">
            <div className="flex justify-center gap-3">
              {otp.map((value, index) => (
                <input
                  key={index}
                  ref={(el) => (inputsRef.current[index] = el)}
                  type="text"
                  maxLength={1}
                  value={value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  id={`otp-${index}`}
                  className={`w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-center rounded-lg text-lg focus:outline-none transition-colors duration-150
                    ${
                      value
                        ? "bg-[#FF6943] text-white border border-[#FF6943]"
                        : "bg-white border border-[#E5E5E5] text-gray-700"
                    }`}
                />
              ))}
            </div>
          </div>

          {/* Error */}
          {error && (
            <p className="text-xs text-red-500 text-center mt-2">{error}</p>
          )}
        </div>

        {/* Resend OTP */}
        <p className="text-sm text-gray-400 mt-6">
          A one-time password has been sent to{" "}
          <span className="font-medium">{forgotEmail}</span>
        </p>
        <p className="text-[#000000] text-base ">
          Resend OTP in {formatTime(seconds)}
        </p>
        <button
          className={
            seconds <= 0
              ? "text-[#FF6943] text-base cursor-pointer underline"
              : "text-gray-400 text-base cursor-not-allowed"
          }
          onClick={handleresendOtp}
          disabled={seconds > 0} // disable button while timer is running
        >
          Resend OTP
        </button>

        <PrimaryBtn
          btnName="Verify OTP"
          extraClass="mt-6"
          clickEvent={handleVerify}
          isLoading={isLoading}
        />

        <p className="text-center text-sm text-gray-500 mt-6">
          Back to{" "}
          <Link
            to={"/login"}
            className="text-[#FF6943] cursor-pointer hover:underline"
          >
            Login
          </Link>
        </p>
      </div>
    </section>
  );
};

export default OtpPage;
